<script>
    /**
     * Alert
     */
    import NormalScrollbar from 'southcn-ui2/src/components/widgets/NormalScrollbar';
    import ModalHeader from 'southcn-ui2/src/components/modals/ModalHeader';
    import moment from 'moment';

    export default {
        alias: 'cast',
        defaultOptions () {
            return {
                title: '系统公告'
            };
        },
        modalCreated (options) {
            for (let key in options) {
                this[key] = options[key];
            }
            if (!('hrefText' in options)) {
                this.hrefText = this.href;
            }
        },
        data () {
            return {
                title: '',
                ui2: false,
                isDrag: true,
                isHideClose: false,
                message: {}
            };
        },
        name: 'modal-alert',
        methods: {
            onDestroy () {
                if (this.okCallback) {
                    this.okCallback();
                }
                this.close();
            },
        },
        components: {
            ModalHeader,
            NormalScrollbar
        },
        computed: {
            compDate () {
                const {publish_time} = this.message;
                return publish_time ? moment.unix(publish_time).format('YYYY-MM-DD HH:mm') : '';
            }
        },
        mounted () {

        }
    };
</script>

<template>
    <div class="modal">
        <modal-header :text="title"
                      :close-icon="ui2 ? undefined : `&#xe620;`"
                      :icon="ui2 ? undefined : `&#xe613;`"
                      :is-hide-close="isHideClose"
                      :is-drag="isDrag"></modal-header>
        <div class="modal-content">
            <normal-scrollbar :height="500">
                <div class="message">
                    <h1 class="message-title">{{message.title}}</h1>
                    <div class="message-date">时间：{{compDate}}</div>
                    <div class="message-content" v-html="message.content"></div>
                </div>
            </normal-scrollbar>
        </div>
    </div>
</template>

<style lang="less" scoped>
    @import '../../../southcn-ui2/src/assets/less/widgets-var.less';

    .modal {
        .modal-style;
        position: absolute;
        width: 800px;
        padding-bottom: 20px;

        .modal-content {
            box-sizing: border-box;
            padding: 20px 0 0 20px;

            .message {

                padding-right: 20px;

                &-title {
                    margin-top: 0;
                }

                &-date {
                    font-size: 16px;
                    color: @otherTextClr;
                }

                &-content {
                    margin-top: 20px;
                    padding-top: 20px;
                    border-top: 1px solid @otherBorderClr;
                }
            }
        }
    }
</style>
